export default __webpack_public_path__ + "static/media/Ignite.636214cc.png";